'use client';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { BsMegaphone } from 'react-icons/bs';
import { RiShieldCheckLine } from 'react-icons/ri';
import { PiUsersThreeDuotone } from 'react-icons/pi';
import { GiPriceTag } from 'react-icons/gi';
import { TbReportAnalytics } from 'react-icons/tb';
import { BsPersonVcard } from 'react-icons/bs';

const HelpSection = () => {
  const muiTheme = useTheme();

  const helpItems = [
    {
      icon: <BsMegaphone color={muiTheme.palette.primary.main} size={36} />,
      title: 'بازاریابی در کل وب و شبکه‌های اجتماعی',
      description:
        'کارشناسان بازاریابی دیجیتال ما با بهره گیری از تجربه و دانش روز دنیا برای دوره ‌های شما تبلیغ میکنندو دیگه نیازی نیست شما نگران تبلیغات در وب سایت ها مطرح و شبکه های اجتماعی باشید!',
    },
    {
      icon: (
        <RiShieldCheckLine color={muiTheme.palette.primary.main} size={36} />
      ),
      title: 'ضد دانلود و ضد سرقت شدن دوره‌ها',
      description:
        'نه تنها با کمک تکنولوژی های روز دنیا دوره های شما را رمز نگاری و ضد دانلود میکنیم  بلکه با استفاده از هوش مصنوعی و یادگیری ماشینی هکر‌ها شناسایی میکنیم و جلوی فعالیتشون میگیریم.',
    },
    {
      icon: (
        <PiUsersThreeDuotone color={muiTheme.palette.primary.main} size={36} />
      ),
      title: 'مدیریت ارتباط با دانشجویان (CRM)',
      description:
        'به آسونی  یک کلیک میتونید به دانشجویان قدیمی خودتون پیامک بزنید و دوره جدید خودتون بهشون معرفی کنید',
    },
    {
      icon: <BsPersonVcard color={muiTheme.palette.primary.main} size={36} />,
      title: 'ایجاد وب سایت شخصی',
      description:
        'به آسونی  یک کلیک میتونید به دانشجویان قدیمی خودتون پیامک بزنید و دوره جدید خودتون بهشون معرفی کنید',
    },
    {
      icon: (
        <TbReportAnalytics color={muiTheme.palette.primary.main} size={36} />
      ),
      title: 'گزارش‌گیری دقیق و نظارت بر رفتار دانشجویان',
      description:
        'با کمک تکنولوژی های روز دنیا دوره های شما را ضد دانلود میکنیم و با استفاده از متخصصین فروش و بازاریابی کمکم میکنیم تا دوره های شما در دوره ساز به بیشترین میزان فروش خودشون دست پیدا کنند',
    },
    {
      icon: <GiPriceTag color={muiTheme.palette.primary.main} size={36} />,
      title: 'قیمت‌گذاری دلخواه',
      description: 'انتخاب سقف و کف قیمت با خودتونه و خودتون تصمیم میگیرید که',
    },
  ];

  return (
    <>
      <Box
        sx={{
          pt: { xs: 0, sm: 0, md: 2 },
        }}>
        <Stack sx={{ alignItems: 'center', gap: 1 }}>
          <Typography
            component="h2"
            sx={{
              fontSize: '24px',
              fontWeight: 500,
              color: 'common.white',
              textAlign: 'center',
              display: { xs: 'block', sm: 'none' },
            }}>
            <span style={{ color: muiTheme.palette.primary.main }}>
              دوره ساز
            </span>{' '}
            چطور به شما کمک می‌کند؟{' '}
          </Typography>
          <Typography
            sx={{
              fontSize: { sm: 36, md: 48 },
              fontWeight: 500,
              color: 'common.white',
              textAlign: 'center',
              display: { xs: 'none', sm: 'block' },
            }}>
            <span style={{ color: muiTheme.palette.primary.main }}>
              دوره ساز
            </span>{' '}
            چطور به مدرسین کمک میکنه؟{' '}
          </Typography>
          <Stack
            sx={{
              textAlign: 'center',
              display: { xs: 'block', sm: 'none' },
            }}>
            <Typography color="common.white" lineHeight="24px">
              دوره ساز پلتفرم جامع برای مدرسین مستقل است که از مرحله محافظت تا
              ایجاد زیر ساخت‌های بازاریابی و فروش تا برنامه جامع وفادار سازی
              دانشجویان در کنارتان می‌باشد
            </Typography>
          </Stack>
          <Stack
            sx={{
              textAlign: 'center',
              display: { xs: 'none', sm: 'block' },
              mt: 1,
            }}>
            <Typography fontSize={18} color="common.white">
              دوره ساز پلتفرم جامع برای مدرسین مستقل است که از مرحله محافظت تا
              ایجاد زیر ساخت‌های بازاریابی و فروش
            </Typography>
            <Typography fontSize={18} color="common.white" mt={1.5}>
              تا برنامه جامع وفادارسازی دانشجویان در کنارتان می‌باشد
            </Typography>
          </Stack>
        </Stack>
        <Box
          sx={{
            pt: 4,
            pb: { xs: 0, sm: 0, md: 4 },
            px: { xs: 0, sm: 2, md: 4 },
          }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              overflow: 'hidden',
              paddingTop: '56.25%',
              cursor: 'pointer',
            }}>
            <iframe
              src={process.env.NEXT_PUBLIC_PLAYER_URL}
              loading="lazy"
              style={{
                border: 'none',
                borderRadius: '15px',
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                width: '100%',
                height: '100%',
              }}
              allow="encrypted-media"
              allowFullScreen={true}
              title="کسب درآمد از فروش دوره"
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HelpSection;
